import { buildAiToolEditPath } from '../../../app-routes';
import type { UnpublishedToolChange } from '@reach/shared-types/agent-components';
import { Link } from 'react-router-dom';
import { getToolHistoryFieldLabel } from '../../ai-tools/tool-history-constants';
import { TOOL_UPDATE_COPY } from './tool-update-copy';
import styles from './UnpublishedChangeItem.module.css';

export const UnpublishedToolChangeItem = ({ change }: { change: UnpublishedToolChange }) => {
  const current =
    change.publishedVersion === null ? TOOL_UPDATE_COPY.newTool : `v${change.publishedVersion}`;
  const versions = `${current} → v${change.latestVersion}`;
  const fields = change.changedFields.map(getToolHistoryFieldLabel).join(', ');
  const detail = fields ? `${versions}: ${fields}` : versions;
  return (
    <li className={styles.unpublishedChangeItem}>
      <strong>{change.name}</strong>
      <span>{detail}</span>
      <Link to={buildAiToolEditPath(change.toolId)}>{TOOL_UPDATE_COPY.reviewHistory}</Link>
    </li>
  );
};
